import { FormContextValue } from '@sec-loans-ui/ifp-loans/types'
import { WizardStep } from '@sec-loans-ui/ifp-loans/wizard/wizardMachine'
import { User } from '@sec-loans-ui/wizard/types'
import { IfpLoan } from '@shared/sec-loans'
import { createContext, use } from 'react'

export const FormContext = createContext<FormContextValue>({
  step: WizardStep.StatusStep,
  exit: () => Promise.resolve(),
  exitWithConfirmDialog: () => null,
  goBack: () => null,
  goBackToStatus: () => null,
  proceed: () => null,
  isStepSubmitting: false,
  hasSubmitFailed: false,
  loan: {} as IfpLoan,
  user: {} as User,
  applicationId: '',
  currentApplicantInfoIndex: 0,
})

export const useIfpFormContext = () => {
  const context = use(FormContext)
  if (context === undefined) {
    throw new Error('useIfpFormContext must be used within a FormContext')
  }
  return context
}
